import TableContainer from 'components/TableContainer'
import _ from 'lodash'
import React,{ useEffect, useCallback, useState, useReducer, useImperativeHandle } from 'react';
import { CellRenderers, getFilterProps, Sorters } from 'utils/tableUtils';
import ActionMenuV2 from 'components/ActionMenuV2';
import { PermissionSetMap } from 'constants/RBACConstants';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { Empty } from 'antd';
import Vocabulary from 'components/Vocabulary';
import message from 'components/CustomMessage';
import EditZoneForm from './EditZoneForm';
import ModalUtil from 'utils/modalUtil';


const initialState = {
    loading: true,
}

const Actions = {
    LOADING: "loading",
    LOADED: "loaded"
}

function reducer(state, action){
    switch (action.type){
        case Actions.LOADING:
            return {
                ...state, 
                loading: true
            };
        case Actions.LOADED:
            return {
                ...state,
                loading: false,
                dataSource: action.payload
            }
        default: 
            return state;
    }
}

function Route53Listing({installtionRef, isAWSInfra}) {
    const [data, setData] = useState();
    const fetchInstallations = useCallback( () => {
        const {promise, cancel} = ToolsIntegrationsAPI[isAWSInfra ? "getAWSIntegrationListing" : "getRoute53hostedZone"]()
        promise.then(
            (data) => {
                const newData = data.map(item => {
                    return {
                        ...item,
                        createdAt: item.route53JpaDto?.createdAt ?? item.createdAt,
                        createdBy: item.route53JpaDto?.createdBy ?? item.createdBy
                    }
                })
                setData(newData)
            },
            e => {
                console.error(e);
            }
        );
        return cancel;
    }, [isAWSInfra])

    useImperativeHandle(
        installtionRef,
        () => ({
            refresh: () => fetchInstallations()
        })
    )

    useEffect(() => {
        fetchInstallations()
        // if(_.isFunction(installtionRef)) {
        //     installtionRef({
        //         refresh: () => fetchInstallations()
        //     })
        // }
    }, [fetchInstallations/* , installtionRef */]);

    const columns = [{
        title: "Id",
        dataIndex: "id",
        sorter: Sorters.NUMBER("id"),
        ...getFilterProps({
            dataIndex: "id",
            dataSource: data
        }),
        width: 60
    }, {
        title: "Account-Id",
        dataIndex: isAWSInfra ? "accountId" : "hostedZoneId",
        width: 120
    },
    // {
    //     title: "Account Name",
    //     dataIndex: "hostedZoneName",
    //     width: 150
    // }, 
    {
        title: "Created By",
        dataIndex: "createdBy",
        sorter: Sorters.STRING("createdBy"),
        render: CellRenderers.VALUE_OR_NA,
        width: 100,
    }, {
        title: "On-boarded Date",
        dataIndex: "createdAt",
        render: CellRenderers.TIME_RELATIVE,
        width: 100,
    }
];

    return (
        <TableContainer
            columns={columns}
            dataSource={data}
            loading={_.isUndefined(data)}
            title={isAWSInfra ? "AWS Installations" : "Route53 Installations"}
            rowKey={"id"}
            hideExpandAll={true}
            showSizeChanger={true}
            expandable={isAWSInfra ? undefined : {
                expandedRowRender: original => <Route53Expandable installation={original} />
            }}
        />
    )
}

export default Route53Listing

export function Route53Expandable({installation}) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const { loading, dataSource } = state;
    const fetchRecords = useCallback( () => {
        dispatch({type: Actions.LOADING})
        const {promise, cancel} = ToolsIntegrationsAPI.getRoute53hostedZoneRecord(installation.id)
        promise.then(
            (data) => {
                dispatch({type: Actions.LOADED, payload: data});
            },
            e => {
                console.error(e);
                dispatch({type: Actions.LOADED, payload: null})
            }
        );
        return cancel;
    }, [installation.id])

    useEffect(fetchRecords, [fetchRecords]);

    if(_.isEmpty(dataSource)){
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={"No Records found."}
            >
            </Empty>
        )
    }

    const onEdit = (data) => {
        ModalUtil.show({
            content: <EditZoneForm recordData={data}/>,
            afterClose: fetchRecords
        })
    }

    const onDelete = async (id) => {
        try{
            await ToolsIntegrationsAPI.deleteRoute53(id).promise;
            message.success("Deleted successfully");
            fetchRecords()
        } catch (err) {
            console.error(err);
        }
    }
    
    const onClick = async (_, record) => {
        const {data} = record
        switch(record.name){
            case "edit": 
                onEdit(data)
                break;
            case "delete":
                await onDelete(data.id)
                break;
            default:
                break;
        }
    }
    const columns = [{
        title: "Record Name",
        dataIndex: "recordName",
        width: 130,
        ellipsis: true,
        sorter: Sorters.STRING("recordName"),
    }, {
        title: "Type",
        dataIndex: "recordType",
        width: 80,
    },{
        title: "Value",
        dataIndex: "recordValues",
        width: 150,
        ellipsis: true,
    }, {
        title:  <Vocabulary name="product" />,
        dataIndex: "product",
        width: 100,
        render: CellRenderers.NAME_ID_MAP
    }, {
        title: <Vocabulary name="subProduct" />,
        dataIndex: "subProduct",
        render: CellRenderers.NAME_ID_MAP,
        width: 110
    },
    {
        title: "Action",
        dataIndex: "id",
        width: 50,
        render: (id, record) => <ActionMenuV2 items={actionItems(record)} data={record} onClick={onClick} />
    }
    ];
    return (
        <TableContainer
            columns={columns}
            dataSource={dataSource}
            title={"DNS Records"}
            rowKey={record => `${record.recordName}-${record.recordType}`}
            loading={loading}
        />
    )
}

const actionItems = (record) => [{
    type: "edit",
    permission: PermissionSetMap.EDIT_TOOL_CONFIG
}, {
    type: "delete",
    permission: PermissionSetMap.DELETE_TOOL,
    disabled: !record?.id,
}]


